import { CognitoAuth } from "amazon-cognito-auth-js";
import UserInfoApi from "./user-info-api";

const {
  REACT_APP_COGNITO_CLIENT_ID,
  REACT_APP_COGNITO_APP_DOMAIN,
  REACT_APP_COGNITO_USERPOOL_ID,
  REACT_APP_COGNITO_REDIRECT_URI_SIGNOUT,
} = process.env;

const CLIENT_ID = REACT_APP_COGNITO_CLIENT_ID as string;
const APP_DOMAIN = REACT_APP_COGNITO_APP_DOMAIN as string;
const REDIRECT_URI = `${window.location.origin}/login/oauth2/code/cognito`;
const USERPOOL_ID = REACT_APP_COGNITO_USERPOOL_ID as string;
const REDIRECT_URI_SIGNOUT = REACT_APP_COGNITO_REDIRECT_URI_SIGNOUT as string;

const authData = {
  ClientId: CLIENT_ID, // Your client id here
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ["openid", "email"],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID,
};

const auth = new CognitoAuth(authData);

auth.userhandler = {
  onSuccess: () => {
    UserInfoApi.getUserInfo().then(() => {
      document.location.href = '/';
    }).catch(error => console.log(error));
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFailure: (err: any) => {
    document.location.href = '/logout';
  },
};

const authModule = {
  auth: auth,
  login(): void {
    auth.getSession();
  },
  logout(): void {
    if (auth.isUserSignedIn()) {
      auth.signOut();
      localStorage.removeItem("token");
    }
  },
};

export default authModule;
